<script setup>
import { ref } from 'vue'
import { useQuasar } from 'quasar'

const $q = useQuasar()

const props = defineProps({
  isDrawerOpen: {
    type: Boolean,
    default: true
  }
})

const emit = defineEmits(['update:isDrawerOpen'])

const isDrawerOpen = ref(props.isDrawerOpen)

function toggleDrawer() {
  isDrawerOpen.value = !isDrawerOpen.value
  emit('update:isDrawerOpen', isDrawerOpen.value)
}
</script>

<template lang='pug'>
.main-page
  q-page-container(:class=`$q.dark.isActive ? 'bg-dark' : 'bg-white'` style="height: 100vh; padding-bottom: 56px;")

    q-header(elevated)
      q-toolbar
        q-btn(flat round dense icon="menu" @click="toggleDrawer" style="margin-left: 16px;")

    router-view
</template>
